
window.addEventListener("DOMContentLoaded", function() {

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mainNav = document.getElementById("mainNav");
  var searchOverlay = document.getElementById("searchOverlay");
  var searchToggle = document.getElementById("searchToggle");
  var searchClose = document.getElementById("searchClose");
  var mobileMenu = document.getElementById("mobileMenu");
  var mobileClose = document.getElementById("mobileClose");

  function onScrollHeader() {
    if (!mainNav) return;
    var sy = window.scrollY;
    if (sy > 60) {
      mainNav.classList.add("frosted");
      mainNav.classList.add("scrolled");
    } else {
      mainNav.classList.remove("frosted");
      mainNav.classList.remove("scrolled");
    }
  }
  onScrollHeader();
  window.addEventListener("scroll", onScrollHeader, { passive: true });

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener("click", function() {
      searchOverlay.classList.toggle("open");
      if (searchOverlay.classList.contains("open")) {
        var si = searchOverlay.querySelector(".search-input");
        if (si) si.focus();
      }
    });
  }
  if (searchClose && searchOverlay) {
    searchClose.addEventListener("click", function() {
      searchOverlay.classList.remove("open");
    });
  }

  var navToggle = document.getElementById("navToggle");
  if (navToggle && mobileMenu) {
    navToggle.addEventListener("click", function() {
      mobileMenu.classList.add("open");
      navToggle.setAttribute("aria-expanded", "true");
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener("click", function() {
      mobileMenu.classList.remove("open");
      if (navToggle) navToggle.setAttribute("aria-expanded", "false");
    });
  }
  if (mobileMenu) {
    mobileMenu.querySelectorAll("a").forEach(function(a) {
      a.addEventListener("click", function() {
        mobileMenu.classList.remove("open");
        if (navToggle) navToggle.setAttribute("aria-expanded", "false");
      });
    });
    mobileMenu.addEventListener("click", function(e) {
      if (e.target === mobileMenu) {
        mobileMenu.classList.remove("open");
        if (navToggle) navToggle.setAttribute("aria-expanded", "false");
      }
    });
  }

  /* Drag support for every slider track (new + legacy markup). Guarded. */
  function wireTrackDrag(track) {
    if (!track || track.getAttribute("data-drag-wired")) return;
    track.setAttribute("data-drag-wired", "1");
    var isDown = false, startX = 0, scrollLeft = 0;
    track.addEventListener("mousedown", function(e) {
      isDown = true;
      track.classList.add("dragging");
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    window.addEventListener("mouseup", function() { isDown = false; track.classList.remove("dragging"); });
    track.addEventListener("mouseleave", function() { isDown = false; track.classList.remove("dragging"); });
    track.addEventListener("mousemove", function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX) * 1.4;
    });
  }
  document.querySelectorAll(".slider-track").forEach(wireTrackDrag);

  /* Legacy tab filter (only if legacy markup present). */
  (function wireTabs() {
    var tabBtns = document.querySelectorAll(".tab-btn");
    if (!tabBtns.length) return;
    var cards = document.querySelectorAll(".card");
    tabBtns.forEach(function(btn) {
      btn.addEventListener("click", function() {
        tabBtns.forEach(function(b) { b.classList.remove("active"); });
        btn.classList.add("active");
        var cat = btn.getAttribute("data-cat");
        cards.forEach(function(c) {
          c.style.display = c.getAttribute("data-cat") === cat ? "" : "none";
        });
        var t = document.getElementById("sliderTrack");
        if (t) t.scrollTo({ left: 0, behavior: "smooth" });
      });
    });
  })();

  /* Legacy slider buttons (only if legacy markup present). */
  (function wireLegacyButtons() {
    var track = document.getElementById("sliderTrack");
    if (!track) return;
    var prev = document.getElementById("prevBtn");
    var next = document.getElementById("nextBtn");
    if (prev) prev.addEventListener("click", function() { track.scrollBy({ left: -360, behavior: "smooth" }); });
    if (next) next.addEventListener("click", function() { track.scrollBy({ left: 360, behavior: "smooth" }); });
  })();

  var hasGsap = (typeof window.gsap !== "undefined") && (typeof window.ScrollTrigger !== "undefined");

  if (reduceMotion) {
    document.querySelectorAll(".reveal, .reveal-clip").forEach(function(el) {
      el.classList.add("in");
      el.style.opacity = "1";
      el.style.transform = "none";
    });
    return;
  }

  if (!hasGsap) return;

  try {
    if (typeof window.ScrollToPlugin !== "undefined") {
      gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
    } else {
      gsap.registerPlugin(ScrollTrigger);
    }
  } catch (e) { return; }

  var heroTL = gsap.timeline({ delay: 0.15 });
  heroTL
    .from(".hero-eyebrow-line", { opacity: 0, x: -30, duration: 0.7, ease: "power3.out" })
    .from(".hero h1 .line span", { yPercent: 115, opacity: 0, duration: 1, ease: "power4.out", stagger: 0.12 }, "-=0.4")
    .from(".hero-sub", { opacity: 0, y: 24, duration: 0.8, ease: "power3.out" }, "-=0.5")
    .from(".hero-ctas .btn", { opacity: 1, y: 20, duration: 0.6, ease: "power3.out", stagger: 0.1 }, "-=0.4")
    .from(".hero-badge", { opacity: 0, y: 30, scale: 0.9, duration: 0.7, ease: "back.out(1.4)" }, "-=0.3")
    .from(".hero-cat-pill", { opacity: 0, y: 16, duration: 0.5, ease: "power3.out", stagger: 0.08 }, "-=0.4");

  gsap.to(".hero-text-block", {
    opacity: 0, y: -60, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "+=400", scrub: 1 }
  });

  gsap.to(".hero-badge", {
    y: -80, opacity: 0, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "+=350", scrub: 1 }
  });

  gsap.to(".hero-categories", {
    y: 60, opacity: 0, ease: "none",
    scrollTrigger: { trigger: ".hero", start: "top top", end: "+=300", scrub: 1 }
  });

  gsap.from(".trio-strip", {
    y: 80, ease: "none",
    scrollTrigger: { trigger: ".trio-strip", start: "top bottom", end: "top 60%", scrub: 1.5 }
  });

  gsap.from(".trio-cell", {
    opacity: 0, y: 60, duration: 0.8, ease: "power3.out", stagger: 0.15,
    scrollTrigger: { trigger: ".trio-strip", start: "top 80%", toggleActions: "play none none none" }
  });

  /* ============================================================
     3. EDITORIAL BANNERS — only when legacy dots/counter markup exists
     ============================================================ */
  (function editorial() {
    var edBanner = document.querySelector(".ed-banner");
    var edRows = gsap.utils.toArray(".ed-banner .ed-row");
    var edDots = document.getElementById("edDots");
    var edCounter = document.getElementById("edCounter");
    if (!edBanner || !edDots || !edCounter || edRows.length < 2) return;
    var edCurrentNum = edCounter.querySelector(".current");
    if (!edCurrentNum) return;
    var edTotal = edRows.length;
    var edDotEls = edDots.querySelectorAll(".dot");
    var edSectionCount = edTotal - 1;
    var edScrollDist = window.innerHeight * edSectionCount;

    edRows.forEach(function(row, i) {
      gsap.set(row, { y: i === 0 ? 0 : "100%", opacity: i === 0 ? 1 : 0, zIndex: i + 1 });
    });

    var edTL = gsap.timeline();

    for (var i = 1; i < edTotal; i++) {
      (function(idx) {
        var prevRow = edRows[idx - 1];
        var currRow = edRows[idx];
        var currImg = currRow.querySelector(".ed-media img");
        var currCopy = currRow.querySelector(".ed-copy");
        var segStart = (idx - 1) / edSectionCount;

        edTL.to(prevRow, {
          y: "-40%", opacity: 0, duration: 0.35, ease: "power2.in"
        }, segStart);

        edTL.to(currRow, {
          y: "0%", opacity: 1, duration: 0.4, ease: "power2.out"
        }, segStart);

        edTL.fromTo(currImg,
          { scale: 1.3 },
          { scale: 1.15, duration: 0.4, ease: "power1.out" },
          segStart
        );

        edTL.fromTo(currCopy,
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 0.35, ease: "power2.out" },
          segStart + 0.05
        );
      })(i);
    }

    ScrollTrigger.create({
      trigger: edBanner,
      start: "top top",
      end: "+=" + edScrollDist,
      pin: true,
      scrub: 0.8,
      anticipatePin: 1,
      animation: edTL,
      onUpdate: function(self) {
        var idx = Math.min(Math.round(self.progress * edSectionCount), edSectionCount);
        edCurrentNum.textContent = String(idx + 1).padStart(2, "0");
        edDotEls.forEach(function(d, di) {
          d.classList.toggle("active", di === idx);
        });
      },
      onEnter: function() { edDots.classList.add("visible"); edCounter.classList.add("visible"); },
      onLeave: function() { edDots.classList.remove("visible"); edCounter.classList.remove("visible"); },
      onEnterBack: function() { edDots.classList.add("visible"); edCounter.classList.add("visible"); },
      onLeaveBack: function() { edDots.classList.remove("visible"); edCounter.classList.remove("visible"); }
    });

    edDotEls.forEach(function(dot) {
      dot.addEventListener("click", function() {
        var idx = parseInt(dot.getAttribute("data-idx"));
        var targetProgress = idx / edSectionCount;
        var st = ScrollTrigger.getAll().filter(function(s) {
          return s.trigger === edBanner;
        })[0];
        if (st) {
          gsap.to(window, {
            scrollTo: { y: st.start + (st.end - st.start) * targetProgress },
            duration: 1.2,
            ease: "power3.inOut"
          });
        }
      });
    });
  })();

  gsap.from(".slider-section .kicker, .slider-section h2", {
    opacity: 0, y: 40, duration: 0.8, ease: "power3.out", stagger: 0.12,
    scrollTrigger: { trigger: ".slider-section", start: "top 80%", toggleActions: "play none none none" }
  });

  // gsap.from(".slider-track .card, .slider-track .product-card", {
  //   opacity: 0, y: 70, scale: 0.92, duration: 0.7, ease: "power3.out", stagger: 0.1,
  //   scrollTrigger: { trigger: ".slider-track", start: "top 85%", toggleActions: "play none none none" }
  // });

  var featureImg = document.querySelector(".feature-visual img");
  if (featureImg) {
    gsap.from(featureImg, {
      scale: 1.3, opacity: 0, duration: 1.4, ease: "power2.out",
      scrollTrigger: { trigger: ".feature-visual", start: "top 75%", toggleActions: "play none none none" }
    });
  }

  gsap.from(".feature h2", {
    opacity: 0, y: 40, duration: 0.8, ease: "power3.out",
    scrollTrigger: { trigger: ".feature h2", start: "top 85%", toggleActions: "play none none none" }
  });

  gsap.from(".feature-list li", {
    opacity: 0, x: -50, duration: 0.6, ease: "power3.out", stagger: 0.1,
    scrollTrigger: { trigger: ".feature-list", start: "top 80%", toggleActions: "play none none none" }
  });

  // var bannerImg = document.querySelector(".banner img");
  // if (bannerImg) {
  //   gsap.from(bannerImg, {
  //     scale: 1.15, opacity: 0, duration: 1.2, ease: "power2.out",
  //     scrollTrigger: { trigger: ".banner", start: "top 75%", toggleActions: "play none none none" }
  //   });
  // }

  gsap.to(".banner-content", {
    y: -40, ease: "none",
    scrollTrigger: { trigger: ".banner", start: "top bottom", end: "bottom top", scrub: 3 }
  });

  var bannerTl = gsap.timeline({
    scrollTrigger: { trigger: ".banner", start: "top 65%", toggleActions: "play none none none" }
  });
  bannerTl
    .from(".banner .quote-mark", { opacity: 0, scale: 0.5, rotation: -90, duration: 0.8, ease: "back.out(1.7)" })
    .from(".banner .quote", { opacity: 0, y: 30, duration: 0.9, ease: "power3.out" }, "-=0.3")
    .from(".banner .cite", { opacity: 0, y: 16, duration: 0.6, ease: "power3.out" }, "-=0.3");

  gsap.from(".gallery .g-item", {
    opacity: 0, y: 70, scale: 0.88, duration: 0.7, ease: "power3.out",
    stagger: { amount: 0.6, from: "random" },
    scrollTrigger: { trigger: ".gallery", start: "top 80%", toggleActions: "play none none none" }
  });

  gsap.from(".testi-section h2", {
    opacity: 0, y: 40, duration: 0.8, ease: "power3.out",
    scrollTrigger: { trigger: ".testi-section", start: "top 80%", toggleActions: "play none none none" }
  });

  document.querySelectorAll(".testi-card, .testi").forEach(function(card, i) {
    var fromX = i % 2 === 0 ? -40 : 40;
    gsap.from(card, {
      opacity: 0, y: 50, x: fromX, duration: 0.7, ease: "power3.out",
      scrollTrigger: { trigger: card, start: "top 88%", toggleActions: "play none none none" }
    });
  });

  var ctaTl = gsap.timeline({
    scrollTrigger: { trigger: ".cta-section", start: "top 75%", toggleActions: "play none none none" }
  });
  ctaTl
    .from(".cta-inner h2", { opacity: 0, y: 40, duration: 0.8, ease: "power3.out" })
    .from(".cta-inner p", { opacity: 0, y: 24, duration: 0.6, ease: "power3.out" }, "-=0.4")
    .from(".cta-actions .btn", { opacity: 0, y: 20, duration: 0.5, ease: "power3.out", stagger: 0.1 }, "-=0.3");

  gsap.to(".cta-ring.r1", { rotation: 360, duration: 25, ease: "none", repeat: -1 });
  gsap.to(".cta-ring.r2", { rotation: -360, duration: 18, ease: "none", repeat: -1 });

  document.querySelectorAll(".section-head").forEach(function(head) {
    var kicker = head.querySelector(".kicker");
    var h2 = head.querySelector("h2");
    var desc = head.querySelector("p");
    var tl = gsap.timeline({
      scrollTrigger: { trigger: head, start: "top 82%", toggleActions: "play none none none" }
    });
    if (kicker) tl.from(kicker, { opacity: 0, x: -30, duration: 0.5, ease: "power3.out" });
    if (h2) {
      var inner = h2.querySelector("span") || h2;
      tl.from(inner, { yPercent: 110, opacity: 0, duration: 0.9, ease: "power4.out" }, "-=0.2");
    }
    if (desc) tl.from(desc, { opacity: 0, y: 16, duration: 0.5, ease: "power3.out" }, "-=0.3");
  });

  document.querySelectorAll(".btn").forEach(function(btn) {
    btn.addEventListener("mousemove", function(e) {
      var rect = btn.getBoundingClientRect();
      var mx = e.clientX - rect.left - rect.width / 2;
      var my = e.clientY - rect.top - rect.height / 2;
      gsap.to(btn, { x: mx * 0.25, y: my * 0.25, duration: 0.3, ease: "power2.out" });
    });
    btn.addEventListener("mouseleave", function() {
      gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: "elastic.out(1,0.4)" });
    });
  });

  document.querySelectorAll(".card").forEach(function(card) {
    card.addEventListener("mousemove", function(e) {
      var rect = card.getBoundingClientRect();
      var cx = (e.clientX - rect.left) / rect.width - 0.5;
      var cy = (e.clientY - rect.top) / rect.height - 0.5;
      gsap.to(card, { rotateY: cx * 8, rotateX: cy * -8, transformPerspective: 800, duration: 0.4, ease: "power2.out" });
    });
    card.addEventListener("mouseleave", function() {
      gsap.to(card, { rotateY: 0, rotateX: 0, duration: 0.6, ease: "elastic.out(1,0.5)" });
    });
  });

  /* ============ SVG FLOATING RINGS (only if ring markup exists) ============ */
  (function rings() {
    var ring1 = document.getElementById("ring1");
    var ring2 = document.getElementById("ring2");
    var ring3 = document.getElementById("ring3");
    if (!ring1 || !ring2 || !ring3) return;
    setTimeout(function() {
      ring1.classList.add("is-drawn");
      ring2.classList.add("is-drawn");
      ring3.classList.add("is-drawn");
    }, 400);

    var vw = window.innerWidth;

    var ringTL = gsap.timeline({
      scrollTrigger: { trigger: "main", start: "top top", end: "bottom bottom", scrub: 3 }
    });

    ringTL
      .to(ring1, { x: vw*0.38, y:320, scale:0.45, rotation:90, ease:"none", duration:1 }, 0)
      .to(ring1, { x: -vw*0.42, y:200, scale:0.3, rotation:180, ease:"none", duration:1 }, 1)
      .to(ring1, { x: vw*0.35, y:-100, scale:0.35, rotation:270, ease:"none", duration:1 }, 2)
      .to(ring1, { x: -vw*0.38, y:50, scale:0.4, rotation:360, ease:"none", duration:1 }, 3)
      .to(ring1, { x: vw*0.4, y:-150, scale:0.25, rotation:450, ease:"none", duration:1 }, 4)
      .to(ring1, { x: -vw*0.35, y:0, scale:0.3, rotation:540, ease:"none", duration:1 }, 5)
      .to(ring1, { x: vw*0.38, y:-80, scale:0.28, rotation:630, ease:"none", duration:1 }, 6)
      .to(ring1, { x:0, y:-200, scale:0.5, rotation:720, opacity:0, ease:"none", duration:1 }, 7)
      .to(ring2, { x: -vw*0.3, y:180, scale:0.5, rotation:-60, ease:"none", duration:1 }, 0)
      .to(ring2, { x: vw*0.28, y:80, scale:0.4, rotation:-120, ease:"none", duration:1 }, 1)
      .to(ring2, { x: -vw*0.25, y:-60, scale:0.55, rotation:-180, ease:"none", duration:1 }, 2)
      .to(ring2, { x: vw*0.32, y:120, scale:0.35, rotation:-240, ease:"none", duration:1 }, 3)
      .to(ring2, { x: -vw*0.3, y:-40, scale:0.45, rotation:-300, ease:"none", duration:1 }, 4)
      .to(ring2, { x: vw*0.25, y:60, scale:0.3, rotation:-360, ease:"none", duration:1 }, 5)
      .to(ring2, { x: -vw*0.28, y:-100, scale:0.4, rotation:-420, ease:"none", duration:1 }, 6)
      .to(ring2, { x: vw*0.15, y:-180, scale:0.6, rotation:-480, opacity:0, ease:"none", duration:1 }, 7)
      .to(ring3, { x: vw*0.2, y:260, scale:0.6, rotation:120, ease:"none", duration:1 }, 0)
      .to(ring3, { x: -vw*0.22, y:140, scale:0.5, rotation:240, ease:"none", duration:1 }, 1)
      .to(ring3, { x: vw*0.18, y:-30, scale:0.7, rotation:360, ease:"none", duration:1 }, 2)
      .to(ring3, { x: -vw*0.2, y:80, scale:0.4, rotation:480, ease:"none", duration:1 }, 3)
      .to(ring3, { x: vw*0.22, y:-80, scale:0.55, rotation:600, ease:"none", duration:1 }, 4)
      .to(ring3, { x: -vw*0.18, y:30, scale:0.45, rotation:720, ease:"none", duration:1 }, 5)
      .to(ring3, { x: vw*0.2, y:-50, scale:0.5, rotation:840, ease:"none", duration:1 }, 6)
      .to(ring3, { x: -vw*0.1, y:-160, scale:0.7, rotation:960, opacity:0, ease:"none", duration:1 }, 7);
  })();

  /* ============ SECTION SVG DECORATIONS ============ */
  document.querySelectorAll(".sec-svg").forEach(function(el) {
    if (!el.parentElement) return;
    ScrollTrigger.create({
      trigger: el.parentElement,
      start: "top 75%",
      onEnter: function() { el.classList.add("is-in"); },
      onLeaveBack: function() { el.classList.remove("is-in"); }
    });
  });

});
